<template>
  <x-page title="支付结果" white-background>
    <div :class="_.status">
      <img :class="_.img" src="./images/error.png" alt="" />

      <div :class="_.text">支付失败</div>
    </div>

    <div :class="_.btn" @click="handlePointPayClick">
      ￥{{ queryParams.payPoint }}消费金 重新去支付
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiTradeGeneralActCouponTradeGetTradeOrderData,
    apiTradeGeneralActCouponTradeIntegralJoinTrade,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { handleGoodsError } from '@/views/goods/exports'
  import { navigateBack, redirectTo } from '@/router'
  import { onPageVisibilityChange, submit, Track } from '@/utils'
  import { wait } from 'vtils'
  const handleGoodsOrderError = handleGoodsError({
    商品下架: () => navigateBack(),
    活动结束: () => navigateBack(),
    活动不能参与: () => navigateBack(),
  })
  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      Track.provideMark(() => ({
        page: '消费金支付结果',
      })),
    ],

    data() {
      return {
        queryParams: {
          preOrderId: '',
          payPoint: '',
        },
      }
    },
    created() {
      const { payPoint, preOrderId } = this.$route.query
      this.queryParams = {
        preOrderId,
        payPoint,
      }
    },

    methods: {
      // 跳转消费金支付
      async handlePointPayClick() {
        await submit(async $ => {
          // 获取商城下单参数
          const tempPayParams =
            await apiTradeGeneralActCouponTradeGetTradeOrderData({
              preOrderId: this.queryParams.preOrderId,
            })
          await $.start()
          const payData = await apiTradeGeneralActCouponTradeIntegralJoinTrade({
            preOrderId: this.queryParams.preOrderId,
            consigneeName: tempPayParams.consigneeAddress.name,
            consigneeTel: tempPayParams.consigneeAddress.phoneNo,
            consigneeAddress: tempPayParams.consigneeAddress,
            tradeOrderInfo: tempPayParams.tradeOrderInfo,
            couponId: tempPayParams.couponId,
            discountAmount: tempPayParams.discountAmount,
            payType: tempPayParams.payType,
            openId: tempPayParams.openId,
          }).catch(handleGoodsOrderError)

          const payUrl = payData.targetUrl

          const off = onPageVisibilityChange(visible => {
            if (visible) {
              off()
              submit(async $ => {
                $.start()
                await wait(1000)
                redirectTo('OrderCenter')
              })
            }
          })
          dcb.navigateTo({
            url: payUrl,
          })
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .status {
    padding-top: 48px;
    text-align: center;
    .img {
      width: 44px;
      height: 44px;
    }
    .price {
      margin-top: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 17px;
      font-style: normal;
      span {
        font-weight: 600;
        font-size: 18px;
        color: #333333;
        line-height: 25px;
      }
    }
    .text {
      margin-top: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #333333;
      line-height: 28px;
      font-style: normal;
    }
  }
  .btn {
    margin: 30px auto 0;
    width: 234px;
    height: 50px;
    text-align: center;
    background: #feecea;
    border-radius: 25px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #fa4234;
    line-height: 50px;
  }
</style>
